module.exports = __webpack_public_path__ + "img/rhino.86dd0b3c.svg";